// custom modules
import axios from "./axios";
import shared from "./util/shared";
import i18n from "./i18n";
import router from "./router";
import Bologna from "./Bologna";
import BolognaEcho from "./BolognaEcho";
window._ = require('lodash');

import purify from "dompurify";

// Vue related modules
import Vue from 'vue';
import VueAxios from 'vue-axios'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Global variables for Vue instance
Vue.prototype.$Echo = BolognaEcho;
Vue.prototype.$shared = shared;
Vue.prototype.$purify = purify;

// Bologna connection
try {
    let proxyHost = document.head.querySelector('meta[name="proxy-host"]').getAttribute('content');
    Vue.prototype.$Bologna = new Bologna(proxyHost);
} catch (e) {
    console.log(`Could not create Bologna instance because: ${e}`)
}


// Vue plugins
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAxios, axios)

// Automatically register components
const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Create vue instance
const app = new Vue({
  i18n,
  router,
  el: '#app',
})

// Remove overlay if JS is enabled
jQuery(function () {
    jQuery('#overlay').remove();
});
